var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"non-selectable-tr"},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.colspanLoginRedirect}},[_c('px-go-to-login-block',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',{staticClass:"body-2"},[_c('a',_vm._g({},on),[_vm._v("Faça login")]),_vm._v(" para ver a tabela de comparação completa ")])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }